import type { FC } from "react"

interface IconProps {
  className: string
  color: string
}

export const PointIcon: FC<IconProps> = (props) => (
  <svg
    fill="none"
    height={8}
    viewBox="0 0 8 8"
    width={8}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 4.004c0 1.477-.725 2.61-1.92 3.307C5.494 7.656 4.732 8 4 8 1.793 8 .181 6.752.005 4.004c-.059-.95.33-1.822.886-2.511.33-.406.953-.75 1.422-1.003C2.878.176 3.31 0 4.007 0c1.377 0 2.447.697 3.165 1.76.432.651.828 1.417.828 2.244"
      fill={props.color ?? "#1D2028"}
    />
    <path
      d="M8 4.004c0 1.477-.725 2.61-1.92 3.307C5.494 7.656 4.732 8 4 8 1.793 8 .181 6.752.005 4.004c-.059-.95.33-1.822.886-2.511.33-.406.953-.75 1.422-1.003C2.878.176 3.31 0 4.007 0c1.377 0 2.447.697 3.165 1.76.432.651.828 1.417.828 2.244Z"
      stroke="none"
    />
  </svg>
)
